import React from 'react';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import FormField, {Props} from '@src/components/Form/FormField';
import {FormFieldProps} from '@src/@types/components/Form';
import {OrderTotalProductsPrice} from '@views/orders/fields/products/OrderTotalProductsPrice';
import OrderTotalPaymentsPrice from '@views/orders/fields/payments/OrderTotalPaymentsPrice';
import {PriceField} from '@src/components/Form/fields';
import {formatPrice} from '@src/helpers/formatters/prices/formatPrice';
import useFormValue from '@src/hooks/useFormValue';
import {IOrderProductModel} from '@src/@interfaces/models/Order/IOrderProductModel';
import {IOrderPaymentModel} from '@src/@interfaces/models/Order/IOrderPaymentModel';

function Field<Model extends IOrderModel = IOrderModel>(props: FormFieldProps<Model>) {
    const {currentValue: products} = useFormValue<IOrderModel, IOrderProductModel[] | undefined>('products');
    const {currentValue: payments} = useFormValue<IOrderModel, IOrderPaymentModel[] | undefined>('payments');

    return <OrderTotalProductsPrice
            products={products}
            modelOptions={props.modelOptions}
    >{productsPrice => {
        return <OrderTotalPaymentsPrice payments={payments}>{paymentsPrice => {
            let residualPrice = productsPrice - paymentsPrice;
            if (residualPrice === 0 && productsPrice === 0 && paymentsPrice === 0) {
                residualPrice = (props.model?.residual_price ?? 0) / 100;
            }

            return <PriceField
                    {...props}
                    forceValue={formatPrice(residualPrice, null, {
                        signDisplay: 'never',
                    })}
                    valueContainerType="text"
            />;
        }}</OrderTotalPaymentsPrice>;
    }}</OrderTotalProductsPrice>;
}

export default function OrderResidualPriceField<Model extends IOrderModel = IOrderModel>(props: Props<Model>) {
    return <FormField
            {...props}
            fieldElement={Field}
    />;
}
